import { GridColDef } from "@mui/x-data-grid";

export const jobTypeColumns: GridColDef[] = [
  { field: "name", headerName: "Name", flex: 1 },
];
